import React, { createContext, useContext, useState } from "react";

import { ModalContextType, ResetData } from "./types";

// Define the types for our modal state

// Create the context with an empty default value
const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Create a provider component
export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isVerifyResetOpen, setIsVerifyResetOpen] = useState(false);
  const [isNewPasswordOpen, setIsNewPasswordOpen] = useState(false);
  const [resetData, setResetData] = useState<ResetData | null>(null);

  const openLoginModal = () => setIsLoginOpen(true);
  const closeLoginModal = () => setIsLoginOpen(false);
  const openSignupModal = () => setIsSignupOpen(true);
  const closeSignupModal = () => setIsSignupOpen(false);
  const openForgotPasswordModal = () => setIsForgotPasswordOpen(true);
  const closeForgotPasswordModal = () => setIsForgotPasswordOpen(false);
  const openVerifyResetModal = () => setIsVerifyResetOpen(true);
  const closeVerifyResetModal = () => setIsVerifyResetOpen(false);

  const openNewPasswordModal = (data?: ResetData) => {
    if (data) setResetData(data);
    setIsNewPasswordOpen(true);
  };
  const closeNewPasswordModal = () => {
    setIsNewPasswordOpen(false);
    setResetData(null);
  };

  return (
    <ModalContext.Provider
      value={{
        isLoginOpen,
        isSignupOpen,
        isForgotPasswordOpen,
        isVerifyResetOpen,
        isNewPasswordOpen,
        resetData,
        openLoginModal,
        closeLoginModal,
        openSignupModal,
        closeSignupModal,
        openForgotPasswordModal,
        closeForgotPasswordModal,
        openVerifyResetModal,
        closeVerifyResetModal,
        openNewPasswordModal,
        closeNewPasswordModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

// Custom hook to use the modal context
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
